const removeKey = ({ map, datastreamId }) => {
    const mapCopy = { ...map };
    delete mapCopy[datastreamId];
    return mapCopy;
};
export const createMultiYAxisSlice = (set) => ({
    yMaxes: {},
    yMins: {},
    setYMax: (datastreamId, value) => set((state) => ({
        yMaxes: {
            ...state.yMaxes,
            [datastreamId]: value,
        },
    })),
    setYMin: (datastreamId, value) => set((state) => ({
        yMins: {
            ...state.yMins,
            [datastreamId]: value,
        },
    })),
    clearYAxis: (datastreamId) => set((state) => ({
        yMins: removeKey({ map: state.yMins, datastreamId }),
        yMaxes: removeKey({ map: state.yMaxes, datastreamId }),
    })),
});
